import { render, staticRenderFns } from "./ListPropertyChangeRequests.vue?vue&type=template&id=6c93c4c4"
import script from "./ListPropertyChangeRequests.vue?vue&type=script&lang=ts"
export * from "./ListPropertyChangeRequests.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports